// extracted by mini-css-extract-plugin
export default {"main":"ProductGrandFrais_main__BN8Im"};